import React, { useState } from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { useTranslation } from "react-i18next";
import ConfirmDialog from "@Components/ConfirmDialog";
import { useNotifyContext } from "components/Notify";
import FormikControl from "components/FormikControl/FormikControl";
import { ZONE_FETCH_URL, REGION_FETCH_URL, ESTATE_FETCH_URL } from "configs/constants";

const AllowableDetailContainer = (props) => {
    const { t } = useTranslation();
    const { id, classes, allowables, setAllowables, isButtonDisabled, setIsButtonDisabled, renderOnly } = props;
    const [disableZone, setDisableZone] = useState(false);
    const [disableRegion, setDisableRegion] = useState(true);
    const [disableEstate, setDisableEstate] = useState(true);
    const [allowableEstate, setAllowableEstate] = useState(null);
    const [allowableRegion, setAllowableRegion] = useState(null);
    const [allowableZone, setAllowableZone] = useState(null);
    const [editId, setEditId] = useState(null);
    const [selectedAllowableValue, setSelectedAllowableValue] = useState();
    const [clearAllowablesValue, setClearAllowablesValue] = useState(false);
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: "", subTitle: "" });
    const setNotify = useNotifyContext();

    

    const getZoneValues = (e) => {
        if (!e || e.length === 0) {
            setDisableRegion(true);
            setAllowableZone(null);
        } else {
            setDisableRegion(false);
            setAllowableZone(e);
        }
    };

    const getRegionValues = (e) => {

        if (!e || e.length === 0) {
            setDisableEstate(true);
            setAllowableRegion(null);
        } else {
            setDisableEstate(false);
            setAllowableRegion(e);
        }
      

    };

    const getEstateValues = (e) => {
        if (!e || e.length === 0) {
            setAllowableEstate(null);
        } else {
            setAllowableEstate(e);
        }
     


    };

    const confirmAllowableAppend = () => {
        if (!allowables[id].editMode) {
            setNotify({
              isOpen: true,
              message: "Record Edited",
              type: "success",
            });
          } else {
            setNotify({
              isOpen: true,
              message: "Record  Added",
              type: "success",
            });  
          }
        setIsButtonDisabled(false);
        if (!allowableZone || Object.keys(allowableZone).length === 0) {
            setNotify({ isOpen: true, message: "Cannot add allowable with empty zone", type: "error" });
            setIsButtonDisabled(true);
            return;
        }
        if (!allowableRegion || Object.keys(allowableRegion).length === 0) {
            setNotify({ isOpen: true, message: "Cannot add allowable with empty region", type: "error" });
            setIsButtonDisabled(true);
            return;
        }
        if (!allowableEstate || Object.keys(allowableEstate).length === 0) {
            setNotify({ isOpen: true, message: "Cannot add allowable with empty estate", type: "error" });
            setIsButtonDisabled(true);
            return;
        }
        if (checkForDuplicates()) {
            setNotify({ isOpen: true, message: "Duplicate entries detected.", type: "error" });
            return;
        }
        setEditId(null);
  
        const payload = { zones: allowableZone, regions: allowableRegion, estates: allowableEstate, confirmed: true, editMode: false };
        const updatedAllowables = [...allowables];
        updatedAllowables[id] = payload;
        setAllowables(updatedAllowables);
        if (allowables[id].editMode) {
          
            if (checkForDuplicates()) {
                setNotify({ isOpen: true, message: "Duplicate entries detected.", type: "error" });
                return;
            }
       return;
        } 
     
    };

    /* const editAllowableAndAppend = async(id) => {
        if (allowables.some((allowable, index) => index !== id && (!allowable.confirmed || allowable.editMode))) {
            setNotify({ isOpen: true, message: "Please confirm the unconfirmed record changes or remove the record.", type: "error" });
            return;
        }
    
        setIsButtonDisabled(true);
        setEditId(id);
    
        await new Promise((resolve) => setTimeout(resolve, 1000));

        let allowable = { ...allowables[id] };
        allowable.confirmed = false;
        allowable.editMode = true;
        const payload = { zones: allowableZone, regions: allowableRegion, estates: allowableEstate, confirmed: true, editMode: false };
        const updatedAllowables = [...allowables];
        updatedAllowables[id] = payload;
        setAllowables(updatedAllowables);
        setTimeout(() => {
        setSelectedAllowableValue(allowable);
        },1000)
        setAllowableZone(allowable.zones);
        setAllowableRegion(allowable.regions);
        setAllowableEstate(allowable.estates);
        setClearAllowablesValue(true);

    }; */
    const editAllowableAndAppend = async (id) => {
        if (allowables.some((allowable, index) => index !== id && (!allowable.confirmed || allowable.editMode))) {
            setNotify({ isOpen: true, message: "Please confirm the unconfirmed record changes or remove the record.", type: "error" });
            return;
        }
    
        setIsButtonDisabled(true);
        setEditId(id); // Ensure `editId` is set correctly
    
        await new Promise((resolve) => setTimeout(resolve, 1000));
    
        const updatedAllowables = allowables.map((item, index) =>
            index === id ? { ...item, confirmed: false, editMode: true } : { ...item, editMode: false }
        );
    
        setAllowables(updatedAllowables);
    
        const allowable = updatedAllowables[id];
    
        setTimeout(() => {
            setSelectedAllowableValue(allowable);
        }, 1000);
    
        setAllowableZone(allowable.zones);
        setAllowableRegion(allowable.regions);
        setAllowableEstate(allowable.estates);
        setClearAllowablesValue(true);
    };
    
      
      
      
      
      
      
      

    const checkForDuplicates = () => {
        if (!allowableEstate) {
            return false;
        }
    
        if (allowableEstate.id === 777) {
            return false;
        }
    
        const estateObjects = allowables
            .filter((a, index) => a && a.estates && index !== id);
     
        for(let i = 0; i < estateObjects.length; i++) {
            const duplicateEstate = estateObjects[i].estates;
    
            //If estate is 'All' 
            if (duplicateEstate.id === 777) {
                continue;
            }
    
            //If zone, region and estate are not same 
            if (duplicateEstate.label === allowableEstate.label && 
                estateObjects[i].regions.label === allowableRegion.label && 
                estateObjects[i].zones.label === allowableZone.label) {
                return true;
            }  
        }
    
        return false;
    };
    /* const removeFromList = (id) => {
        if (isButtonDisabled || (allowables[id].editMode && allowables[id].estates !== null && allowables[id].regions !== null && allowables[id].zones !== null)) {
            setNotify({ isOpen: true, message: "Please confirm the unconfirmed record changes", type: "error" });
            return;
        }              
       
        const hasData = allowables[id].zones || allowables[id].regions || allowables[id].estates;

        if (!hasData) {
            const updatedAllowables = allowables.filter((item, index) => index !== parseInt(id));
            setAllowables(updatedAllowables);
            setNotify({ isOpen: true, message: "Record deleted successfully", type: "success" });
            setIsButtonDisabled(false);

        } else {
            setConfirmDialog({
                isOpen: true,
                title: "Are you sure to delete this record?",
                subTitle: "YOU CANNOT UNDO THIS OPERATION",
                onConfirm: () => {
                   const updatedAllowables = allowables.filter((item, index) => index !== parseInt(id));
                    setAllowables(updatedAllowables);
                    setNotify({ isOpen: true, message: "Record deleted successfully", type: "success" });
                    setConfirmDialog(prev => ({ ...prev, isOpen: false }));
                    setIsButtonDisabled(false); 

                },
            });
        }
    } */

        const removeFromList = (id) => {
            const hasData = allowables[id]?.zones || allowables[id]?.regions || allowables[id]?.estates;
          
            const handleRecordRemoval = (idToRemove) => {
              console.log("Allowable test: Starting removal process...");
              console.log("Allowable test: Initial allowables:", allowables);
              console.log("Allowable test: Initial editId:", editId);
          
              // Create a deep copy of the allowables to avoid direct state mutation
              let updatedAllowables = [...allowables];
          
              // Remove the record from the updated allowables
              updatedAllowables.splice(idToRemove, 1);
              console.log("Allowable test: Allowables after deletion:", updatedAllowables);
          
              // Find the record that is in edit mode
              const editIndex = updatedAllowables.findIndex(record => record.editMode);
          
              // If there is a record in edit mode and it's not already the first record
              if (editIndex !== -1 && editIndex !== 0) {
                // Move the editMode record to the 0th index
                const [editRecord] = updatedAllowables.splice(editIndex, 1);
                updatedAllowables.unshift(editRecord);
              }
          
              // Ensure editMode is disabled for all records
              const finalAllowables = updatedAllowables.map(item => ({
                ...item,
                editMode: false,
              }));
          
              console.log("Allowable test: Final allowables after processing:", finalAllowables);
          
              // Update state with the new list
              setAllowables(finalAllowables);
              setEditId(null);
          
              // Clear related states
              setSelectedAllowableValue(null);
              setAllowableZone(null);
              setAllowableRegion(null);
              setAllowableEstate(null);
          
              setNotify({ isOpen: true, message: "Record deleted successfully", type: "success" });
              setIsButtonDisabled(false);
          
              console.log("Allowable test: Removal process completed.");
            };
          
            if (!hasData) {
              handleRecordRemoval(id);
            } else {
              setConfirmDialog({
                isOpen: true,
                title: "Are you sure to delete this record?",
                subTitle: "YOU CANNOT UNDO THIS OPERATION",
                onConfirm: () => {
                  handleRecordRemoval(id);
                  setConfirmDialog((prev) => ({ ...prev, isOpen: false }));
                },
              });
            }
          };
                       
                    
                         
                
          
          

    return renderOnly ? (
        <>
            <Grid item container direction="row" spacing={2} xs={12} className={classes.tableStyle}>
                <Grid item lg={4}>
                    <FormikControl
                        control="reactselect"
                        variant="outlined"
                        name="zones"
                        fullWidth
                        multiline
                        paginated={false}
                        isPaginationEnabled={false}
                        size="medium"
                        proxyUrl={ZONE_FETCH_URL}
                        placeholder={"Select Zone"}
                        disabled={true}
                        getValue={(e) => getZoneValues(e)}
                        clearAllowables={clearAllowablesValue}
                        selectedDefaultObjectValue={selectedAllowableValue?.zones || null}
                    />
                </Grid>
                <Grid item lg={4}>
                    <FormikControl
                        control="reactselect"
                        variant="outlined"
                        name="regions"
                        fullWidth
                        multiline
                        paginated={true}
                        size="medium"
                        optionsDependsOn={"zones"}
                        proxyUrl={REGION_FETCH_URL}
                        disabled={true}
                        getValue={(e) => getRegionValues(e)}
                        clearAllowables={clearAllowablesValue}
                        selectedDefaultObjectValue={selectedAllowableValue?.regions || null}
                    />
                </Grid>
                <FormikControl
                    control="reactselect"
                    variant="outlined"
                    name="estates"
                    fullWidth
                    multiline
                    paginated={true}
                    size="medium"
                    optionsDependsOn={"regions"}
                    proxyUrl={ESTATE_FETCH_URL}
                    disabled={true}
                    getValue={(e) => getEstateValues(e)}
                    clearAllowables={clearAllowablesValue}
                    selectedDefaultObjectValue={selectedAllowableValue?.estates || null}
                />
            </Grid>
            <ConfirmDialog confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} />
        </>
    ) : (
        <>
            <Grid item container direction="row" spacing={2} xs={12} >
                <Grid item lg={3} style={!allowables[id].editMode && id !== editId ? { display: 'flex', justifyContent: 'center', alignItems: 'center' } : null} >
                    {!allowables[id].editMode && id !== editId ? (
                        <FormikControl
                            control="renderonly"
                            name="zones"
                            key="zones"
                            value={allowables[id]?.zones?.label}
                            clearAllowables={clearAllowablesValue}
                        />
                    ) : (
                        <FormikControl
                            control="reactselect"
                            variant="outlined"
                            name="zones"
                            fullWidth
                            multiline
                            paginated={false}
                            isPaginationEnabled={false}
                            size="medium"
                            proxyUrl={ZONE_FETCH_URL}
                            disabled={disableZone}
                            dynamicLabel="Select Zones"
                            getValue={(e) => getZoneValues(e)}
                            clearAllowables={clearAllowablesValue}
                            selectedDefaultObjectValue={selectedAllowableValue?.zones || null}
                        />
                    )}
                </Grid>
                <Grid item lg={3} style={!allowables[id].editMode && id !== editId ? { display: 'flex', justifyContent: 'center', alignItems: 'center' } : null}>
                    {!allowables[id].editMode && id !== editId ? (
                        <FormikControl
                            control="renderonly"
                            name="regions"
                            key="regions"
                            value={allowables[id]?.regions?.label}
                            clearAllowables={clearAllowablesValue}
                        />
                    ) : (
                        <FormikControl
                            control="reactselect"
                            variant="outlined"
                            name="regions"
                            fullWidth
                            multiline
                            paginated={false}
                            isPaginationEnabled={false}
                            size="medium"
                            optionsDependsOn={"zones"}
                            proxyUrl={REGION_FETCH_URL}
                            disabled={disableRegion}
                            dynamicLabel="Select Regions"
                            getValue={(e) => getRegionValues(e)}
                            clearAllowables={clearAllowablesValue}
                            selectedDefaultObjectValue={selectedAllowableValue?.regions || null}
                        />
                        
                    )}
                </Grid>
                <Grid item lg={3} style={!allowables[id].editMode && id !== editId ? { display: 'flex', justifyContent: 'center', alignItems: 'center' } : null}>
                    {!allowables[id].editMode && id !== editId ? (
                        <FormikControl
                            control="renderonly"
                            name="estates"
                            key="estates"
                            value={allowables[id]?.estates?.label}
                            clearAllowables={clearAllowablesValue}
                        />
                    ) : (
                        <FormikControl
                            control="reactselect"
                            variant="outlined"
                            name="estates"
                            fullWidth
                            multiline
                            paginated={false}
                            isPaginationEnabled={false}
                            size="medium"
                            optionsDependsOn={"regions"}
                            proxyUrl={ESTATE_FETCH_URL}
                            disabled={disableEstate}
                            dynamicLabel="Select Estates"
                            getValue={(e) => getEstateValues(e)}
                            clearAllowables={clearAllowablesValue} //This props is used to clear the dropdowns after add new allowables.
                            selectedDefaultObjectValue={selectedAllowableValue?.estates || null} //This porps is used for selected value for dropdown.
                            hasAllSelected={{ "id": 777, code: "777", name: "All" }} //For all estate to be selected we passed unique ID 777 from backend
                        />
                    )}
                </Grid>
                <Grid item lg={3} className={classes.actionColumn}>
                    {!allowables[id].editMode && id !== editId ? (
                        <Button
                            variant="contained"
                            className={classes.button}
                            onClick={() => editAllowableAndAppend(id)}
                            disabled={isButtonDisabled || allowables[id].editMode}
                        >
                            {t("Edit")}
                        </Button>
                    ) : (
                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.button}
                            onClick={() => confirmAllowableAppend(id)}
                        >
                            {t("Confirm")}
                        </Button>
                    )}
                    <Button variant="contained" className={classes.button} onClick={() => removeFromList(id)}  disabled={!allowables[id].editMode && isButtonDisabled } >
                        {t("Delete")}
                    </Button>
                </Grid>
            </Grid>
            <ConfirmDialog confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} />
        </>
    );
};

AllowableDetailContainer.propTypes = {
    id: PropTypes.string,
    classes: PropTypes.object,
    allowables: PropTypes.array,
    setAllowables: PropTypes.func,
    isButtonDisabled: PropTypes.bool,
    renderOnly: PropTypes.bool,
    setIsButtonDisabled: PropTypes.func,
};

export default AllowableDetailContainer;